import { Link } from "@mui/material";
import { TbShirtSport } from "react-icons/tb";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";

export const WinstonSalemDashLink = () => (
  <Link
    target="_blank"
    href="https://mlb.tickets.com/renewals/?agency=DWSM_MYTIXX&orgid=57592#&myticketsRenewEnabled=true"
    sx={{
      fontWeight: 500,
      color: "primary.main",
      textDecoration: "none",
    }}
  >
    MyProVenue
  </Link>
);

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Choose Your Games",
    description: "Select the games you wish to attend.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Login to MLB.com.",
    description:
      "Click Continue and connect your Winston-Salem Dash account using our secure MLB.com login.",
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Seats",
    description: "Select the seats you wish to purchase for each game.",
  },
  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description: (
      <>
        Tickets will be available in your <WinstonSalemDashLink /> within 24
        hours of purchase. Reach out to LIve Fan Support for any questions
      </>
    ),
  },
];

export const faqs = [
  {
    title: "How does the Dash Build Your Own Pack Program work?",
    description: (
      <>
        The Dash Build Your Own Pack Program allows fans to select any seat to
        select games hosted by the Winston-Salem Dash. Simply log into your{" "}
        <Link
          target="_blank"
          href="https://mlb.tickets.com/renewals/?agency=DWSM_MYTIXX&orgid=57592#&myticketsRenewEnabled=true"
          sx={{
            fontWeight: 500,
            color: "primary.main",
            textDecoration: "none",
          }}
        >
          MLB.com
        </Link>{" "}
        and select games.
      </>
    ),
  },
  {
    title: "Do I have to select all my games now?",
    description: "Yes, you must select all games at the time of purchase.",
  },
  {
    title: "Can I choose seats throughout the venue?",
    description: "Yes, you can choose from all current available inventory.",
  },
  {
    title: "Where are event tickets delivered?",
    description: (
      <>
        Tickets are delivered directly within your Dash <WinstonSalemDashLink />{" "}
        Account.
      </>
    ),
  },
];
